 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"adminPanel":"adminPanel","order":"order","landing":"landing","compare":"compare"}[chunkId]||chunkId) + "." + {"chunk-39831589":"7f302295","chunk-f1885426":"171c99cf","chunk-744baed6":"4505371f","chunk-a6ff9380":"003916ce","chunk-378d9cce":"a2be5a60","chunk-7b52c948":"90576cf4","chunk-010926c0":"4f73fd9b","chunk-75b71062":"c1644b67","chunk-0a68b6f5":"e6f140fb","chunk-559e0de2":"3d4799ba","chunk-54f065f2":"26db36f9","chunk-60c7c234":"8f0a2340","chunk-68dfdca9":"256eda4b","adminPanel":"1a0df72e","chunk-2e751935":"52b02f49","chunk-9c49ac7c":"45d70d51","chunk-a41eddb2":"cae7628d","order":"917ed2c5","landing":"689ba8c2","compare":"0db9a35e","chunk-10e44cf8":"efc7a686","chunk-15b30e06":"f9e8f929","chunk-17805e98":"0e7b6112","chunk-250f7264":"f0921df1","chunk-2ad3dd8c":"f5ec270d","chunk-1abf8c34":"600b07c7","chunk-2bb943fe":"f8ed1aff","chunk-2ed4c226":"b4de98bf","chunk-33dd3c27":"2a01b6d8","chunk-3e365366":"77125513","chunk-50543afe":"b19c566b","chunk-5349f91f":"b463dbb2","chunk-2e49a155":"212f8d60","chunk-f4c7cc58":"7d28c389","chunk-a30f03d8":"fd44faf4","chunk-656b0dd6":"9a7d1ef3","chunk-fc16f11e":"8bd129f0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-f1885426":1,"chunk-378d9cce":1,"chunk-010926c0":1,"chunk-75b71062":1,"chunk-0a68b6f5":1,"chunk-559e0de2":1,"chunk-54f065f2":1,"chunk-60c7c234":1,"chunk-68dfdca9":1,"adminPanel":1,"chunk-2e751935":1,"chunk-9c49ac7c":1,"chunk-a41eddb2":1,"order":1,"landing":1,"compare":1,"chunk-10e44cf8":1,"chunk-15b30e06":1,"chunk-17805e98":1,"chunk-250f7264":1,"chunk-2ad3dd8c":1,"chunk-1abf8c34":1,"chunk-2bb943fe":1,"chunk-2ed4c226":1,"chunk-33dd3c27":1,"chunk-3e365366":1,"chunk-50543afe":1,"chunk-5349f91f":1,"chunk-2e49a155":1,"chunk-f4c7cc58":1,"chunk-a30f03d8":1,"chunk-656b0dd6":1,"chunk-fc16f11e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"adminPanel":"adminPanel","order":"order","landing":"landing","compare":"compare"}[chunkId]||chunkId) + "." + {"chunk-39831589":"31d6cfe0","chunk-f1885426":"b5ec6e20","chunk-744baed6":"31d6cfe0","chunk-a6ff9380":"31d6cfe0","chunk-378d9cce":"cebeb59a","chunk-7b52c948":"31d6cfe0","chunk-010926c0":"0943e77d","chunk-75b71062":"d4453a7e","chunk-0a68b6f5":"a3a1f51e","chunk-559e0de2":"7768c020","chunk-54f065f2":"3595ca5d","chunk-60c7c234":"7a182256","chunk-68dfdca9":"b741c3ba","adminPanel":"0e172191","chunk-2e751935":"27facbbc","chunk-9c49ac7c":"e7ed97f5","chunk-a41eddb2":"89425998","order":"895fdbfd","landing":"1fde56ee","compare":"6952b937","chunk-10e44cf8":"68df1cba","chunk-15b30e06":"d2e71a82","chunk-17805e98":"68df1cba","chunk-250f7264":"68df1cba","chunk-2ad3dd8c":"b64561d1","chunk-1abf8c34":"051e66aa","chunk-2bb943fe":"8c518b1e","chunk-2ed4c226":"215f856f","chunk-33dd3c27":"1052ae83","chunk-3e365366":"68df1cba","chunk-50543afe":"8eae1b88","chunk-5349f91f":"0e433876","chunk-2e49a155":"68df1cba","chunk-f4c7cc58":"68df1cba","chunk-a30f03d8":"68df1cba","chunk-656b0dd6":"312780c8","chunk-fc16f11e":"9027d810"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
